import { debounce } from 'lodash';
import axiosApi from './axios/axios.js'

class Reporter {
  defaultInfo = {
    productName: '官网',
    type: 'PAGE'
  };
  storages = [];

  constructor() {
    this.emit = debounce(this.emit.bind(this), 500, { leading: false, trailing: true });
  }

  log(options) {
    const newInfo = { ...this.defaultInfo, msg: options.message || 'message为空', pageUrl: location.href };
    if (options.code) {
      newInfo.code = options.code;
      newInfo.params = options.requestInfo;
    }
    this.storages.push(newInfo);
    this.emit();
  }

  async emit() {
    if (this.storages.length) {
      const storages = [...this.storages];
      this.storages = [];
      let errArr = storages.map(item => {
        return new Promise(resolve => {
          try {
            resolve({ ...item, params: JSON.stringify(item.params) });
          } catch (err) {
            resolve({ ...item, params: err.message || 'emit json转义失败' });
          }
        });
      });
      errArr = await Promise.all(errArr);

      try {
        await axiosApi.httpPost('admin/exception', errArr);
      } catch (err) {
        console.error(err);
      }
    }
  }
}

export default new Reporter();



// WEBPACK FOOTER //
// ./src/reporter.js